<template>
	<div>
		<div class="game" v-show="!reaction">
			<div class="shulte__body">
				<div class="train__info" v-if="active">
					<div class="train__item" uk-tooltip="Следующее число">
						<div class="train__ico train__ico--1"></div>
						<small>Следующее число:</small>
						<span :class="getNextCif.type">{{ getNextCif.value }}</span></div>
					<div class="train__item" uk-tooltip="Ошибок">
						<div class="train__ico train__ico--2"></div>
						<small>Ошибок:</small>
						{{ errors }}
					</div>
					<div class="train__item" v-if="$route.params.isHomework" uk-tooltip="Выполнено">
						<div class="train__ico train__ico--4"></div>
						<small>Выполнено:</small>
						<div class="train__nowrap">{{ $route.params.total }} из {{ $route.params.qnt }}</div>
					</div>
					<div class="train__item" uk-tooltip="Времени прошло">
						<div class="train__ico train__ico--3"></div>
						<div>
							<small>Времени прошло:</small>
							<!--<br class="uk-visible@s">-->
							{{ timer.minutes }} мин. {{ timer.seconds }} сек.
						</div>
					</div>
				</div>

				<div class="shulte__table" v-if="active" :style="'grid-template: repeat(' + params.size + ', 1fr) / repeat(' + params.size + ', 1fr);'">
					<div class="shulte__item shulte__item--gorbov" v-for="i in shuffle" :key="i.id" :class="i.type" @click="checkNumber($event, i)">{{ i.value }}</div>
				</div>
			</div>
			<div v-if="params.finish">
				<h2>Отлично! Молодец! Повторим?</h2>
				<h3>Твоё время - {{ timer.minutes }} мин. {{ timer.seconds }} сек.</h3>
				<p class="scores">И ты зарабатываешь
					<strong>{{ scores }}</strong> {{ $root.getNoun(scores, 'балл', 'балла', 'баллов') }}!</p>
				<button class="uk-button uk-button-primary" @click="startGame" v-if="!checkFinishHomework()">Повторить!</button>
				<button class="uk-button uk-button-primary" @click="onStopTrainer" v-else>Закончить</button>

			</div>
			<a href="#" @click.prevent="onStopTrainer">Остановить</a>
		</div>

		<div class="wh-block wh-block--reaction" v-if="reaction">
			<div class="reaction">
				<!--<video loop muted preload="auto" autoplay>-->
				<video disableRemotePlayback preload="auto" autoplay @ended="stopReaction">
					<source type="video/mp4" :src="'/storage/app/media/reactions/' + reaction_file" id="mp4">
				</video>
			</div>
		</div>
	</div>
</template>

<script>
  import { mapState } from 'vuex';
  import { mix } from "./../mixin";

  export default {
    name: "game",
    mixins: [
      mix
    ],
    props: {
      inkey: ''
    },
    data() {
      return {
        cifs: '',
        shuffle: '',
        active: false,
        step: 0,
        errors: 0,
        nextCif: '',
        currentCif: '',
        reaction: false,
        scores: 0,
      }
    },
    computed: {
      getNextCif() {
        return this.cifs[this.step];
      },
      user() {
        return this.$store.state.user;
      },
      finish() {
        return this.params.finish
      },
      ...mapState({
        params: state => state.train.gorbov_params
      })
    },
    methods: {
      shuffleArray(arr) {
        let j, temp;
        for (let i = arr.length - 1; i > 0; i--) {
          j = Math.floor(Math.random() * (i + 1));
          temp = arr[j];
          arr[j] = arr[i];
          arr[i] = temp;
        }
        return arr;
      },

      nexStep() {
        this.step++;
        if (this.step == this.cifs.length) {
          this.$parent.commitVal(true, 'finish');
          this.stopGame();
          this.addScores();
          this.makeStats();
          this.startReaction();
        }
      },
      checkNumber(event, i) {
        let el = event.target;
        let next = this.getNextCif;
        if (i == next) {
          el.classList.add("pass");

          el.classList.add("success");
          setTimeout(function () {
            el.classList.remove("success");
          }, 500);

          this.nexStep();
        } else {
          el.classList.add("error");
          setTimeout(function () {
            el.classList.remove("error");
          }, 500);
          this.errors++;
        }
      },
      stopGame() {
        this.active = false;
        this.$parent.commitVal(true, 'finish');
      },

      init() {
        let cifs = [];
        let b = 1;
        let size = this.params.size;
        let qnt = size * size + 1;
        let r = Math.round((qnt / 2)) + 1;
        console.log(size, qnt, r);
        for (let i = 1; i < qnt; i++) {
          if ((i % 2)) {
            cifs.push({
              'value': b,
              'type': 'black'
            });
            b++;

          } else {
            cifs.push({
              'value': r,
              'type': 'red'
            });
            r--;
          }
        }
        this.cifs = cifs;
        this.shuffle = this.shuffleArray(cifs.slice());
      },
      startGame() {
        this.$parent.commitVal(false, 'finish');
        this.scroll();
        this.init();
        this.step = 0;
        if (!this.$route.params.is_matrius) {
          this.errors = 0;
        }
        
        this.startTimer();
        this.active = true;
      },
      addScores() {
        let sum = 0;
        if (this.errors < 10) {
          let scores = ((this.params.size * this.params.size) * (1 - (this.errors / 10))) * 1.3;

          sum = Math.ceil(scores);

          if (this.$route.params.isHomework) {
            sum = Math.ceil(sum * this.$store.state.hw_coefficient);
          }
          this.checkScoreStatus(sum);
          this.scores = sum;
        }
        this.$store.commit('changeUserScores', sum);
        console.log('Баллов заработано', sum);
      },
      async makeStats() {
        console.log("Make stats");
        if (this.user.role.code === 'student') {
          console.log('Бережно сохраняем статистику');
          let path = this.$route.params.is_matrius ? 'onSaveMatriusAnswer' : 'onSaveStats'
          let hasActive = this.active;
          if (!hasActive) {
            let time = this.timer;
            let errors = this.errors;
            let train_params = this.params;
            let stats = {
              time: time,
              errors: errors,
              hasActive: hasActive,
              user_id: this.$store.state.user.id,
              trainer: this.$store.state.current_trainer.id,
              scores: this.scores,
              train_params: {
                size: +train_params.size
              }
            }            
            
            stats = this.checkHomework(stats);

            if (this.$route.params.is_matrius) {
              stats.student_task_id = this.$route.params.student_task_id
              stats.qnt = this.$route.params.qnt
              stats.count = this.$route.params.total
            }

            let data = {
              'stat': stats
            }

            this.http.post(path, data).then((res) => {
              console.log(res);
              this.checkCoins(res.data);

              if (this.$route.params.is_matrius && res.data.is_done) {
                swal('Успешно!', res.data.message, 'success')
              }
            });
          }
        } else {
          console.log('Учителей в статистику не заносим! Понятно?!');
        }
      },
      /** РЕАКЦИИ */
      startReaction() {
        if (this.params.show_reactions) {
          let type = (this.errors === 0 ? 'react_plus' : 'react_minus');
          this.reaction_file = this.checkReaction(type);
          this.reaction = true;
        }
      },
      stopReaction() {
        this.reaction = false;
        let app = this;
        setTimeout(function () {
          app.scroll();
          $('#repeat-' + app.inkey).focus();
        }, 100);
      },
      scroll() {
        UIkit.scroll('.headline2').scrollTo('.game');
      }
    },
    inject: ['http'],
    mounted() {
      this.startGame();
    },
    beforeDestroy() {
      //this.makeStats();
      this.$parent.commitVal(false, 'start')
    }
  }
</script>